import React, { useContext, createContext, useState, useEffect } from "react";
import { AuthContext } from "../../AuthContext"
import { jwtDecode } from "jwt-decode"
import axios, { all } from "axios"
import { useFormik } from "formik"
import * as yup from "yup"
import { useNavigate } from "react-router-dom"


export const TransportOwnerContext = createContext()
export const TransportOwnerProvider = ({ children }) => {
  const { token } = useContext(AuthContext)
  const [data, setData] = useState([])
  // const [username, setUserName] = useState("")
  // const [role, setRole] = useState("")
  // const [profile, setProfile] = useState("")
  // const [name,setName]=useState("")
  // const [email,setEmail]=useState('')
  // const[id,setId]=useState(0)
  const [transportOwnerData,setTransportOwnerData]=useState({
    name:"",
    email:"",
    profile:"",
    username:"",
    id:0,
    role:""
  })
  const [availableTransporters, setAvailableTransporters] = useState([])
  const [relToDelete, setRelToDelete] = useState(false)
  // Value to hold the farmer that is related to the transporting company that a user owns
  const [transporterFarmer, setTransporterFarmer] = useState([])
  // Value to hold the customerr that is related to the transporting company that a user owns
  const [transporterCustomer, setTransporterCustomer] = useState([])
  // Value of the transporting companies that a transporterowner has
  const [ownerTransporters, setOwnerTransporters] = useState([])
  // Value of the hotel_owner  that uses the transporting company 
  const [transportHotelOwner, setTransportHotelOwner] = useState([])
  // Value to hold the admins
  const [admins, setAdmins] = useState([])  
  const baseUrl=process.env.REACT_APP_SECOND_BACKEND_URL;
  const navigate = useNavigate()

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token)
      const {role,username,email,profile,id,name}=decodedToken?.sub
      if(role!=="transport_owner"){
        navigate("/unauthoriaed")
      }
      fetchTransportOwnerData(id)
      setTransportOwnerData((prev)=>({
        ...prev,
        name:name?name:prev?.name,
        id:id?id:prev?.id,
        profile:profile?profile:prev?.profile,
        email:email?email:prev?.email,
        username:username?username:prev?.username,
        role:role?role:prev?.role,
      }))       
    }
    else{
      navigate("/loginUser")
    }

  }, [token])


  // useEffect(() => {
  //   if (token ) {
  //     axios.get(`${baseUrl}/transporters`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type":"application/json"
  //       }
  //     }).then(res => {
  //       const allTransporters = res.data  
  //       // console.log("data",data)      
  //       if (data[0]?.Transporters?.length > 0) {
  //         const ownerTransporters=data[0]?.Transporters?.map(trans=>trans.id)
  //         // console.log("ownerTransporters",ownerTransporters)
  //         const filteredTransporters=allTransporters.filter(trans=>!ownerTransporters.includes(trans.id))          
  //         setAvailableTransporters(filteredTransporters)          
  //       }
  //       else {
  //         setAvailableTransporters(allTransporters)
  //       }
  //     }).catch(error => {
  //       console.error("Error fetching transporters", error)
  //     })      
  //   }
  // }, [token, data])

  // console.log("availabelTransporters",availableTransporters)
  // Function to fetch a transport_owners data
  const fetchTransportOwnerData = (userId) => {    
    axios.get(`${baseUrl}/transport_owners/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      const allData = response.data
      // console.log("allData",allData)
      setData(allData)
      let allTransporters=allData[0]?.AllTransporters;    
      let transOwnerTransporters=allData[0].Transporters;
      if (transOwnerTransporters.length>0) {
        if(allTransporters.length>0){
          let transpoterOwnerIds=transOwnerTransporters.map(trans=>trans.id)
          const filteredTransporters=allTransporters.filter(trans=>!transpoterOwnerIds.includes(trans.id));
          setAvailableTransporters(filteredTransporters)
        }
        setOwnerTransporters(transOwnerTransporters)
        const hotelOwners = allData[0].Transporters.flatMap((transporter) =>
          transporter?.hotels?.flatMap((hotel) => hotel.owners)
        );
        if(hotelOwners.length>0){
        const uniqueHotelOwners = [...new Set(hotelOwners.map(owner => owner?.username))].map(username => hotelOwners.find(owner => owner.username === username))
        setTransportHotelOwner(uniqueHotelOwners);
        }
        // Set the transporterCustomer to the customer that a user has
        const newCustomers = transOwnerTransporters.flatMap(trans => trans?.customers)
        if(newCustomers.length>0){
          const uniqueCustomers = [...new Set(newCustomers.map(customer => customer?.username))].map(username => newCustomers.find(trans => trans.username === username))
        setTransporterCustomer(uniqueCustomers)
        
        }
        const newFarmers = transOwnerTransporters.flatMap(trans => trans?.farmers)
         if(newFarmers.length>0){
          const uniqueFarmers = [...new Set(newFarmers.map(farmer => farmer.username))].map(username => newFarmers.find(farmer => farmer.username === username))
        setTransporterFarmer(uniqueFarmers)
         }

        
      }
      else{
        setAvailableTransporters(allTransporters)
      }
    }).catch(error => {
      console.error("Error fetching transporters", error)
    })   
  }

  // Run this useEffect when the value of admins change
  useEffect(() => {
    fetchAdmins()
  }, [])
  const fetchAdmins = async () => {
    try {
      await axios.get(`${baseUrl}/admins`)
        .then(res => {
          const newAdmins = res.data
          setAdmins(newAdmins)
        })
        .catch(error => {
          console.error(`An error ocuured fetching admins ${error}`)
        })

    } catch (error) {
      console.error(`An error occurred fetching admins`, error)
    }

  }
  const requestAddTransporter = async (values) => {
    try {
      const res = await fetch(`${baseUrl}/login/admin/transport_owners`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(values)
      })
      if (res.ok) {
        alert(`${values.name} added successfully`)
        fetchTransportOwnerData(transportOwnerData?.id)
        setAvailableTransporters(availableTransporters.filter((transporter) => transporter.name !== values.name))
      }
      else {
        if (res.status===500){
          alert(`An error ocuured adding ${values?.name},please try again`)
          return
        }
        else{
          let errorMessage=await res.json()
          alert(`An error ocuured adding ${values?.name} : ${errorMessage?.Error || errorMessage?.Message}`)
        }
      }
    } catch (error) {
      console.error(`An error occurred  sending message ${error}`)
    }
  }

  const requestDeleteTransporter = async (values) => {
    try {
      if (!window.confirm(`Are you sure you want to delete ${values.name}`)) return;
      else {
        const res = await fetch(`${baseUrl}/login/admin/transport_owners`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(values)
        })
        if (res.ok) {
          alert(`${values.name} deleted successfuly`)
          fetchTransportOwnerData(transportOwnerData?.id)
          //  setAvailableTransporters(availableTransporters.filter((transporter,index)=>transporter.name!==values.name))
        }
        else {
          if (res.status===500){
            alert(`An error ocuured adding ${values?.name},please try again`)
            return
          }
          else{
            let errorMessage=await res.json()
            alert(`An error ocuured adding ${values?.name} : ${errorMessage?.Error || errorMessage?.Message}`)
          }
          }
        
      }
    }
    catch (error) {
      console.error("Error deleting transporters", error)
    }
  }
  // Function to fetchProfile
  useEffect(() => {
    if (transportOwnerData?.profile) {
      fetchProfile()
    }

  }, [transportOwnerData?.username])
  const fetchProfile = async () => {
    try {
      const res = await fetch(`${baseUrl}/uploads/${transportOwnerData?.username}_profile_picture.png`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (res.ok) {
        let blob = await res.blob()
        let url = URL.createObjectURL(blob)
        setTransportOwnerData((prev)=>({
          ...prev,
          profile:url
        }))
      }
      else{
        setTransportOwnerData(prevValues=>({
          ...prevValues,
          profile:""

        }))
      }
    } catch (error) {
      console.error(`An error occurred fetching profiles`, error)
    }

  }
  const handleSendMessage = async (values) => {
    try {
      const res = await fetch(`${baseUrl}/messages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(values)
      })
      if (res.ok) {
        // alert("Message sent successfully")
        fetchTransportOwnerData(transportOwnerData?.id)
      }
      else {
        // alert("An error ocuurred")
        console.error("An error occurred sending message", res.statusText)
      }
    } catch (error) {
      console.error("An error occurred sending message", error)
    }
  }
  const formik = useFormik({
    initialValues: {
      name: "",
      transporter_owner_username:transportOwnerData?.username
    },
    validationSchema: yup.object().shape(
      {
        name: yup.string(" Name should be a string").required("Name is required").typeError("Name should be a string")
      }
    ),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (relToDelete) {
          await requestDeleteTransporter(values)
        }
        else {
          await requestAddTransporter(values)
        }
      } catch (error) {
        console.error("An error occurred", error)
      }
      finally {
        setSubmitting(false)
      }
    }
  })
  
 useEffect(()=>{
 if (transportOwnerData?.username){
  formik.setFieldValue("transporter_owner_username",transportOwnerData?.username)
 }
 },[transportOwnerData?.username])
  // console.log(admins)
  const [postsPerPage, setPostPerPage] = useState(4)
  const [currentPage, setCurrentPage] = useState(1)
  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const newTransporterData = ownerTransporters.length > 4 ? ownerTransporters.slice(indexOfFirstPost, indexOfLastPost) : ownerTransporters
  // State to hold the customers who use the transporting copmany that transport owner has

  const paginate = (num) => {
    setCurrentPage(num)
  }

  const contextValues = {
    transportOwnerData,
    handleSendMessage, newTransporterData, postsPerPage, currentPage, paginate, transportHotelOwner, admins, ownerTransporters,   token, data, setRelToDelete, relToDelete, transporterCustomer, transporterFarmer, availableTransporters, baseUrl, formik, requestAddTransporter, requestDeleteTransporter
  }
  return (
    <div>
      <TransportOwnerContext.Provider value={contextValues}>
        {children}
      </TransportOwnerContext.Provider>
    </div>
  )
}